// Mock data for Redline Monitoring Services Inc. website - Focused on HOA Communities and Dedicated Guards

export const hoaTestimonials = [
  {
    id: 1,
    name: "Marcus Chen",
    location: "Austin, TX", 
    role: "Property Manager",
    content: "Before Redline, our security was outsourced to a rotating cast of guards who never learned the property. Now a dedicated guard — backed by their monitoring team — actually watches our community in real time. Package and mailbox theft stopped, and residents finally feel known.",
    rating: 5,
    community: "Riverside Gate Condominiums – 180 units",
    keyBenefit: "100% elimination of mail theft and seamless gate management"
  },
  {
    id: 2,
    name: "Jennifer Martinez",
    location: "Cedar Park, TX",
    role: "HOA Vice President",
    content: "Our old company ran a notification queue — software pinged and someone maybe glanced. Redline is the opposite. Our guard knows which residents have visitors, watches deliveries live, and catches anything out of place the moment it happens.",
    rating: 5,
    community: "Hill Country Condominiums – 95 units",
    keyBenefit: "Personal monitoring and intimate community knowledge"
  },
  {
    id: 3,
    name: "Robert Johnson",
    location: "Round Rock, TX",
    role: "HOA Treasurer", 
    content: "The difference is real monitoring. They don't wait for an alert — they're watching. Our dedicated guard manages gate access, knows our vendors, and has built real trust with residents. Insurance claims have dropped dramatically since we switched.",
    rating: 5,
    community: "Brushy Creek Residences – 150 units",
    keyBenefit: "80% reduction in insurance claims through proactive security"
  }
];

export const companyStats = [
  { label: "HOA Communities Served", value: "200+", icon: "home" },
  { label: "Dedicated Guards Deployed", value: "200+", icon: "users" },
  { label: "Average Incident Reduction", value: "75%", icon: "shield" },
  { label: "Client Retention Rate", value: "98%", icon: "heart" }
];

export const dedicatedGuardBenefits = [
  {
    title: "Exclusive Property Assignment",
    description: "Your Virtual Guard is assigned only to your community - never pulled away to other properties or emergency calls.",
    icon: "users"
  },
  {
    title: "Resident Recognition",
    description: "Knows residents by sight, understands their routines, and can immediately identify when someone doesn't belong.",
    icon: "eye"
  },
  {
    title: "Pattern Learning",
    description: "Learns your property's daily rhythms, visitor patterns, and normal activity to spot anomalies instantly.",
    icon: "brain"
  },
  {
    title: "Proactive Prevention",
    description: "Intervenes before incidents occur rather than responding after damage is done.",
    icon: "shield"
  }
];

// Mock form submission handlers
export const handleConsultationRequest = (formData) => {
  console.log("Consultation request submitted:", formData);
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ 
        success: true, 
        message: "Thank you! Our security expert will contact you within 4 hours to schedule your consultation.",
        consultationId: "RL" + Math.floor(Math.random() * 10000)
      });
    }, 1500);
  });
};

export const handleContactForm = (formData) => {
  console.log("Contact form submitted:", formData);
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Message sent! We'll respond within 24 hours." });
    }, 1000);
  });
};

export const handleNewsletterSignup = (email) => {
  console.log("Newsletter signup:", email);
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Successfully subscribed to HOA security updates!" });
    }, 800);
  });
};